module.exports = __webpack_public_path__ + "img/Carousel.c8def775.jpg";